import styled from "styled-components"
import { WithTip } from 'components/tooltip/with-tip'
import keyService, * as chord from "data/key"
import toggles from 'feature-toggles'
import { HeaderIcon_s } from 'components/wrapper/header/header-styles'
import calcService from "data/calc"
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import Isvg from 'react-inlinesvg'
import { ShortcutHint_s } from 'styles/shortcut-styles'
import { CalcIcon } from "images/icons/header"


const NewCalc = () => {
  const [hintsVisible, setHintsVisible] = useState<boolean>(false)

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_ALT && k.down === true:
          setHintsVisible(true)
          break
        case k.chord === chord.CTRL_ALT && k.down === false:
          setHintsVisible(false)
          break
        case k.chord === chord.CTRL_ALT_B && k.down === true:
          newCalc()
          break
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  }, [])

  function newCalc() {
    calcService.newCalc()
  }

  if(toggles.displayNewCalc()) {
    return (
      <div>
        <HeaderIcon_s>
          <WithTip position="bottom">
            <span>New Calc</span>
            <a onClick={(e)=>newCalc()}>
              <Isvg src={CalcIcon} id={"newCalcIcon"} />
              { hintsVisible && <ShortcutHint_s className="header-hint" visible={hintsVisible}>B</ShortcutHint_s> }
            </a>
          </WithTip>
        </HeaderIcon_s>
      </div>
    )
  } else return null
}

export default NewCalc;
